import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { announcementQueries } from '../api/announcement';
import useNotificationApiInstance from './useNotificationApiInstance';

import type { UseQueryOptions } from '@tanstack/react-query';
import type { AnnouncementDetail } from '../api/announcement';

export interface UseGetAnnouncementDetailOptions
  extends Omit<
    UseQueryOptions<AnnouncementDetail>,
    keyof ReturnType<typeof announcementQueries.detail>
  > {}

/**
 * 새소식 상세를 조회합니다.
 * @description
 * - 조회 대상 전환 시 이전 데이터를 유지(keepPreviousData)해 화면 깜빡임을 막습니다.
 */
const useGetAnnouncementDetail = (
  announcementId: string,
  options?: UseGetAnnouncementDetailOptions,
) => {
  const { endpoint, instance } = useNotificationApiInstance();

  return useQuery({
    ...announcementQueries.detail(instance, announcementId),
    enabled: Boolean(endpoint) && Boolean(announcementId),
    placeholderData: keepPreviousData,
    ...options,
  });
};

export default useGetAnnouncementDetail;
